export function SaveToFavorites() {
    $(document).ready(function() {
        const submitBtn = $('[data-trigger="auth-true"]');
        const tooltipSelector = $('[data-toggle="tooltip"]');
        var requestSent = false;

        submitBtn.on('change', function() {
            if (requestSent === false) {
                requestSent = true;
                const checkbox = $(this).find('input[type="checkbox"]');
                const itemId = $(this).data('item-key');

                console.log(itemId);

                if(checkbox.is(':checked')) {
                    $.ajax({
                        url: `/properties/${ itemId }/favorite`,
                        type: 'GET',
                        data: {
                            favorite: true
                        },
                        success: function (data) {
                            toastr.success('Обявата е добавена в "Любими"', 'Добавяне на обява');
                            toastr.clear();
                            //console.log(data)
                        },
                        complete: function() {
                            tooltipSelector.tooltip('hide');
                            requestSent = false;
                        },
                        error: function (err) {
                            console.log(err);
                        }
                    });

                } else {
                    $.ajax({
                        url: `/properties/${ itemId }/favorite`,
                        type: 'GET',
                        data: {
                            favorite: false
                        },
                        success: function () {
                            toastr.info('Обявата е премахната от "Любими"', 'Премахване на обява');
                        },
                        complete: function() {
                            tooltipSelector.tooltip('hide');
                            requestSent = false;
                        },
                        error: function (err) {
                            console.log(err);
                        }
                    });

                }
            }
        });
    });
}